export default __webpack_public_path__ + "static/media/Group 3098.4172d3f8.svg";